export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  isAdding: (state) => state.isAdding,
  isRefreshing: (state) => state.isRefreshing,
  approvalStates: (state) => state.approvalStates,
  list: (state) => state.list,
  paging: (state) => state.paging,
  summaries: (state) => state.summaries,
  nextPage: (state) => state.paging?.next_page,
  totalSummary: (state) =>
    state.summaries.filter(
      (summary) => summary.legal_entity_type === 'TOTAL',
    )[0],
};
